__turbopack_context__.v({
  "active": "STHeader-module__8F4Xeq__active",
  "closeBtn": "STHeader-module__8F4Xeq__closeBtn",
  "dropdown": "STHeader-module__8F4Xeq__dropdown",
  "dropdownIcon": "STHeader-module__8F4Xeq__dropdownIcon",
  "dropdownLink": "STHeader-module__8F4Xeq__dropdownLink",
  "hamburger": "STHeader-module__8F4Xeq__hamburger",
  "header": "STHeader-module__8F4Xeq__header",
  "letsConnectBtn": "STHeader-module__8F4Xeq__letsConnectBtn",
  "logo": "STHeader-module__8F4Xeq__logo",
  "navItem": "STHeader-module__8F4Xeq__navItem",
  "navLink": "STHeader-module__8F4Xeq__navLink",
  "navLinkWrapper": "STHeader-module__8F4Xeq__navLinkWrapper",
  "navList": "STHeader-module__8F4Xeq__navList",
  "offWhiteHeader": "STHeader-module__8F4Xeq__offWhiteHeader",
  "open": "STHeader-module__8F4Xeq__open",
  "overlay": "STHeader-module__8F4Xeq__overlay",
  "scrolled": "STHeader-module__8F4Xeq__scrolled",
});
